import { giphyBlack, giphyYellow } from '@giphy/js-brand'
import styled, { css } from 'styled-components'
import ControlSize, {
    controlBorderRadius,
    controlFontShadow,
    controlFontSize,
    controlHeight,
} from '../../../types/control-size'
import Gradient, { gradientCss } from '../../../types/gradient'
import { brightnessFromColor } from '../../../utils/color/brightness'

export const Label = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`

export const Icon = styled.span`
    display: inline-block;
    font-size: 0.9em;
    font-weight: normal;
    line-height: 1;
    vertical-align: middle;

    > i {
        display: inline-block;
        height: 1em;
        margin-top: 0.2em;
        width: 1em;
    }

    > svg {
        display: inline-block;
    }

    &:first-child {
        margin-right: 0.5em;
    }

    &:last-child {
        margin-left: 0.5em;
    }

    &:only-child {
        margin-left: 0;
        margin-right: 0;
    }
`

export const Button = styled.button<{
    controlColor: string
    controlSize: ControlSize
    gradient?: Gradient
    textColor?: string
}>`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    font-weight: bold;
    justify-content: center;
    line-height: normal;
    user-select: none;
    border: none;

    &:disabled {
        opacity: 0.5;
        pointer-events: none;
    }

    &:active {
        opacity: 0.8;
    }

    &:focus-visible {
        outline: 2px solid ${giphyYellow};
    }

    ${({ controlColor, controlSize, gradient, textColor }) => {
        const color = textColor || (brightnessFromColor(controlColor) > 0.5 ? giphyBlack : '#fff')

        return css`
            background: ${gradient ? gradientCss(gradient) : controlColor};
            border-radius: ${controlBorderRadius(controlSize)}px;
            color: ${gradient ? textColor || '#fff' : color};
            font-size: ${controlFontSize(controlSize)}px;
            height: ${controlHeight(controlSize)}px;
            min-width: ${controlHeight(controlSize)}px;
            padding: 0 1em;

            ${Label} {
                line-height: ${controlHeight(controlSize)}px;
            }

            ${Icon} > svg {
                height: ${Math.round(controlHeight(controlSize) * 0.4)}px;
                width: ${Math.round(controlHeight(controlSize) * 0.5)}px;

                path {
                    fill: ${color};
                }
            }
        `
    }}

    ${({ controlSize, gradient }) =>
        gradient &&
        css`
            > span {
                filter: drop-shadow(${controlFontShadow(controlSize)});
            }
        `}
`
